import { render } from "./ScreenWrapper.vue?vue&type=template&id=73a064d0&ts=true"
import script from "./ScreenWrapper.vue?vue&type=script&lang=ts"
export * from "./ScreenWrapper.vue?vue&type=script&lang=ts"

import "./ScreenWrapper.vue?vue&type=style&index=0&id=73a064d0&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__